var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "svg",
      {
        attrs: {
          width: "244",
          height: "208",
          viewBox: "0 0 344 208",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }
      },
      [
        _c("path", {
          attrs: {
            d:
              "M338.502 139.678L13.7944 168.814C12.2 168.955 10.6148 168.458 9.38651 167.43C8.15821 166.403 7.3871 164.93 7.24235 163.334L0.023516 82.6914C-0.117487 81.0952 0.379654 79.5081 1.40589 78.2783C2.43213 77.0486 3.90366 76.2765 5.49769 76.1316L330.206 46.9954C331.8 46.8542 333.385 47.352 334.614 48.3794C335.842 49.4069 336.613 50.8802 336.758 52.4761L343.976 133.118C344.118 134.715 343.62 136.302 342.594 137.531C341.568 138.761 340.096 139.533 338.502 139.678V139.678Z",
            fill: "#2962FF"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M51.7381 144.082C65.7419 144.082 77.0943 132.716 77.0943 118.696C77.0943 104.675 65.7419 93.3093 51.7381 93.3093C37.7342 93.3093 26.3818 104.675 26.3818 118.696C26.3818 132.716 37.7342 144.082 51.7381 144.082Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M108.556 96.6053C107.441 96.7074 106.412 97.2483 105.695 98.109C104.978 98.9698 104.632 100.08 104.732 101.196C104.832 102.313 105.37 103.344 106.228 104.063C107.087 104.783 108.195 105.132 109.31 105.034L307.742 87.2282C308.296 87.1794 308.834 87.0218 309.326 86.7645C309.819 86.5072 310.256 86.1552 310.612 85.7286C310.969 85.3021 311.238 84.8094 311.404 84.2787C311.57 83.748 311.63 83.1897 311.58 82.6358C311.531 82.0819 311.373 81.5432 311.115 81.0505C310.857 80.5578 310.505 80.1209 310.078 79.7646C309.652 79.4083 309.159 79.1397 308.629 78.9742C308.099 78.8087 307.541 78.7494 306.988 78.7998L108.556 96.6053Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M110.819 121.89C110.266 121.939 109.727 122.096 109.235 122.354C108.742 122.611 108.305 122.963 107.948 123.389C107.591 123.816 107.322 124.309 107.156 124.84C106.99 125.37 106.93 125.929 106.979 126.483C107.029 127.037 107.187 127.576 107.445 128.069C107.703 128.562 108.055 128.999 108.482 129.355C108.909 129.711 109.401 129.98 109.932 130.145C110.463 130.31 111.02 130.37 111.574 130.319L310.006 112.513C310.559 112.465 311.098 112.307 311.59 112.05C312.083 111.792 312.52 111.44 312.876 111.014C313.233 110.587 313.501 110.095 313.668 109.564C313.834 109.033 313.894 108.475 313.844 107.921C313.794 107.367 313.636 106.828 313.379 106.336C313.121 105.843 312.769 105.406 312.342 105.05C311.916 104.693 311.423 104.425 310.893 104.259C310.363 104.094 309.805 104.035 309.252 104.085L110.819 121.89Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M274.823 7.73124L270.667 3.68552C268.244 1.32572 264.956 0 261.528 0C258.1 0 254.813 1.32572 252.389 3.68552L171.784 82.159L91.1801 3.68552C88.7562 1.32572 85.4687 0 82.0408 0C78.613 0 75.3255 1.32572 72.9016 3.68552L68.746 7.73124C67.5459 8.8997 66.5938 10.2868 65.9443 11.8135C65.2948 13.3401 64.9604 14.9764 64.9604 16.6289C64.9604 18.2813 65.2948 19.9176 65.9443 21.4442C66.5938 22.9709 67.5459 24.358 68.746 25.5265L149.35 104L68.746 182.474C67.5459 183.642 66.5938 185.029 65.9443 186.556C65.2948 188.082 64.9604 189.719 64.9604 191.371C64.9604 193.024 65.2948 194.66 65.9443 196.187C66.5938 197.713 67.5459 199.1 68.746 200.269L72.9016 204.314C75.3255 206.674 78.613 208 82.0408 208C85.4687 208 88.7562 206.674 91.1801 204.314L171.784 125.841L252.389 204.314C254.813 206.674 258.1 208 261.528 208C264.956 208 268.244 206.674 270.667 204.314L274.823 200.269C277.247 197.909 278.609 194.708 278.609 191.371C278.609 188.034 277.247 184.833 274.823 182.474L194.219 104L274.823 25.5265C277.247 23.1667 278.609 19.9661 278.609 16.6289C278.609 13.2916 277.247 10.091 274.823 7.73124V7.73124Z",
            fill: "#FF6584"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            opacity: "0.1",
            d:
              "M65.8691 186.74L144.08 110.597L143.327 109.864L68.7457 182.474C67.4964 183.689 66.5173 185.141 65.8691 186.74V186.74Z",
            fill: "black"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            opacity: "0.1",
            d:
              "M67.6312 10.2822C70.055 7.92243 73.3425 6.5967 76.7704 6.5967C80.1983 6.5967 83.4857 7.92243 85.9096 10.2822L166.514 88.7558L247.118 10.2822C249.542 7.92243 252.83 6.5967 256.258 6.5967C259.686 6.5967 262.973 7.92243 265.397 10.2822L269.552 14.3279C271.335 16.0639 272.557 18.2698 273.069 20.6736C273.58 23.0775 273.357 25.5744 272.429 27.8568L274.823 25.5265C276.023 24.358 276.975 22.9709 277.624 21.4442C278.274 19.9175 278.608 18.2813 278.608 16.6289C278.608 14.9764 278.274 13.3402 277.624 11.8135C276.975 10.2869 276.023 8.89969 274.823 7.73124L270.667 3.68552C268.243 1.32572 264.956 1.79906e-05 261.528 1.79906e-05C258.1 1.79906e-05 254.812 1.32572 252.389 3.68552L171.784 82.159L91.1797 3.68552C88.7558 1.32572 85.4684 0 82.0405 0C78.6126 0 75.3251 1.32572 72.9012 3.68552L68.7457 7.73124C67.4964 8.94626 66.5173 10.3985 65.8691 11.9977L67.6312 10.2822Z",
            fill: "black"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            opacity: "0.1",
            d:
              "M194.971 104.733L188.948 110.597L269.553 189.07C271.335 190.806 272.558 193.012 273.069 195.416C273.58 197.82 273.358 200.317 272.429 202.599L274.823 200.269C276.023 199.1 276.975 197.713 277.624 196.186C278.274 194.66 278.608 193.024 278.608 191.371C278.608 189.719 278.274 188.082 277.624 186.556C276.975 185.029 276.023 183.642 274.823 182.473L194.971 104.733Z",
            fill: "black"
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-699812d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-699812d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoAccessImage.vue
// module id = null
// module chunks = 